import { render, staticRenderFns } from "./SiteDocumentEdit.vue?vue&type=template&id=39d10b7e"
import script from "./SiteDocumentEdit.vue?vue&type=script&lang=js"
export * from "./SiteDocumentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports